import React from "react";
import KenWidget from "../KenWidget";

function KenFieldContent(props) {
	// const { data, formJSON, activeStep, currentStepDetails } = props;
	// console.log("props in  KenFieldContent", props);

	return (
		<>
			<KenWidget {...props}></KenWidget>
		</>
	);
}
export default KenFieldContent;
